/**
 * Returns images used by the editor - Theme Thumbnails.
 *
 * @param {string} path for assets, defaults to '/' relative
 * @return {object} key/value for each asset.
 */
export function getEditorImages(root = '/') {
  const getUrl = path => root + path;
  return {
    // Clean Theme Thumbnail
    'images/clean-thumb.jpg': getUrl(
      require('./resources/images/clean-thumb.jpg')
    ),
    // Capital Theme Thumbnail
    'images/capital-thumb.jpg': getUrl(
      require('./resources/images/capital-thumb.jpg')
    ),
    // Vigor Theme Thumbnail
    'images/vigor-thumb.jpg': getUrl(
      require('./resources/images/vigor-thumb.jpg')
    ),
    // Cordial Theme Thumbnail
    'images/cordial-thumb.jpg': getUrl(
      require('./resources/images/cordial-thumb.jpg')
    ),
    // Glam Theme Thumbnail
    'images/glam-thumb.jpg': getUrl(
      require('./resources/images/glam-thumb.jpg')
    ),
    // Gather Theme Thumbnail
    'images/gather-thumb.jpg': getUrl(
      require('./resources/images/gather-thumb.jpg')
    ),
    // Twist Theme Thumbnail
    'images/twist-thumb.jpg': getUrl(
      require('./resources/images/twist-thumb.jpg')
    ),
    // Serene Theme Thumbnail
    'images/serene-thumb.jpg': getUrl(
      require('./resources/images/serene-thumb.jpg')
    )
  };
}

/**
 * Returns images used by the guest side render - Theme Backgrounds.
 *
 * @param {string} path for assets, defaults to '/' relative
 * @return {object} key/value for each asset.
 */
export function getContentImages(root = '/') {
  const getUrl = path => root + path;
  return {
    // Clean Theme Header and Footer
    'images/clean-header.png': getUrl(
      require('./resources/images/clean-header.png')
    ),
    'images/clean-footer.png': getUrl(
      require('./resources/images/clean-footer.png')
    ),
    // Capital Theme Header and Footer
    'images/capital-header.png': getUrl(
      require('./resources/images/capital-header.png')
    ),
    'images/capital-footer.png': getUrl(
      require('./resources/images/capital-footer.png')
    ),
    // Vigor Theme Header and Footer
    'images/vigor-header.png': getUrl(
      require('./resources/images/vigor-header.png')
    ),
    'images/vigor-footer.png': getUrl(
      require('./resources/images/vigor-footer.png')
    ),
    // Cordial Theme Header and Footer
    'images/cordial-header.png': getUrl(
      require('./resources/images/cordial-header.png')
    ),
    'images/cordial-footer.png': getUrl(
      require('./resources/images/cordial-footer.png')
    ),
    // Glam Theme Header and Footer
    'images/glam-header.png': getUrl(
      require('./resources/images/glam-header.png')
    ),
    'images/glam-footer.png': getUrl(
      require('./resources/images/glam-footer.png')
    ),
    // Glam Theme Header and Footer
    'images/gather-header.png': getUrl(
      require('./resources/images/gather-header.png')
    ),
    'images/gather-footer.png': getUrl(
      require('./resources/images/gather-footer.png')
    ),
    // Twist Theme Header and Footer
    'images/twist-header.png': getUrl(
      require('./resources/images/twist-header.png')
    ),
    'images/twist-footer.png': getUrl(
      require('./resources/images/twist-footer.png')
    ),
    // Serene Theme Header and Footer
    'images/serene-header.png': getUrl(
      require('./resources/images/serene-header.png')
    ),
    'images/serene-footer.png': getUrl(
      require('./resources/images/serene-footer.png')
    )
  };
}
